module.exports = __webpack_public_path__ + "src/assets/img/lyberetskaya.4179eb4a.jpg";